module.exports = __webpack_public_path__ + "static/media/ppbg.87a35617.png";